/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectGcpOrganizationRequest {
  /**
  * The organization ID.
  */
  'organizationId': string;
  /**
  * GCP Organization management service account ID.
  */
  'managementServiceAccountId': string;
  /**
  * Glob patterns for project IDs to exclude (e.g., internal-*, test-*)
  */
  'excludeProjectPatterns'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "organizationId",
      "baseName": "organizationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementServiceAccountId",
      "baseName": "managementServiceAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "excludeProjectPatterns",
      "baseName": "excludeProjectPatterns",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectGcpOrganizationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

